/**
 * Build a GCS public URL from a storage bucket + object path.
 *
 * Idempotent: a ref that's already an absolute http(s) URL is returned unchanged.
 * Re-prepending the bucket to a full URL produced a nested, un-fetchable URL that
 * broke background removal with a fal.ai 500 (MATTOBOARD-730). A storage object path
 * is never http(s)://, so the guard only skips the prefix for already-absolute refs.
 *
 * Kept firebase-free (no SDK imports) so it stays unit-testable on its own.
 */
export function toPublicURL(storageBucket: string, filePath: unknown): string {
  if (typeof filePath === "string" && /^https?:\/\//i.test(filePath)) {
    return filePath;
  }
  return "https://storage.googleapis.com/" + storageBucket + "/" + filePath;
}
